import React from "react";
import "./HavelAbout.scss";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import cgb from "../../Media/Havel.webp";
const rumah = () => {
  return (
    <div id="havel" className="rumahjasmia">
      <h1>Welcome to Cluster Havel</h1>
      <h2>Cicilan Start From 7 Juta/Bulan</h2>
      <div className="herojasmia">
        <img className="fotohome" src={cgb} alt={cgb} />
        <div className="desk-jasmia">
          Cluster Havel adalah salah satu klaster perumahan di CitraLand City
          Kedamean, Gresik, yang menawarkan berbagai tipe rumah dengan desain
          modern dan fasilitas lengkap. Klaster ini dirancang untuk memenuhi
          kebutuhan keluarga akan hunian yang nyaman dan strategis. Cluster
          Havel di CitraLand City Kedamean dirancang untuk menyediakan berbagai
          fasilitas yang mendukung kenyamanan dan kualitas hidup penghuninya.
          Fasilitas yang tersedia meliputi Clubhouse, Jogging Track, Thematic
          Park, Children Playground dan Multipurpose Lounge.
        </div>
      </div>
    </div>
  );
};

export default rumah;
